import i18n from '@app/plugins/i18n';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { isID } from '@shared/helpers/uid';
import { from_element } from '@app/plugins/iview-modal-modify/animate/from-element';
import { WorksheetItemService } from '@autoinformer/services/WorksheetItemService';
import { WorksheetActionModelSelector } from '@autoinformer/helpers/worksheets/action-types';

import Entry from '@autoinformer/components/worksheets/action-types/modals/entry';
import Menu from '@autoinformer/components/worksheets/action-types/modals/menu';
import Playback from '@autoinformer/components/worksheets/action-types/modals/playback';
import Postback from '@autoinformer/components/worksheets/action-types/modals/postback';
import ConnectionWithTimeout from '@autoinformer/components/worksheets/action-types/modals_conection/with-timeout';
import PhoneKeyboard from '@autoinformer/components/worksheets/action-types/modals_conection/phone-keyboard';
import PositiveNegative from '@autoinformer/components/worksheets/action-types/modals_conection/positive-negative';

class WorksheetActionModalService extends ModalService {
  _default_success(item) {
    this.$emit('success', item);
    this.modal.remove();
  }

  _default_error(e) {
    this.$emit('error', e);
  }

  remove(worksheet_id, id, item, $el) {
    return this.$confirm({
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('pbx.worksheet.modal.remove_action.content', {
        name: `<strong>${item.name}</strong>`
      }),
      loading: true,
      animate: from_element($el),
      onOk: () => {
        if (isID(id)) {
          WorksheetItemService.removeItem(item.type, worksheet_id, id)
            .then(() => this._default_success({ id }))
            .catch(e => this._default_error(e))
            .finally(() => this.modal.setLoading(false));
        } else {
          this._default_success({ id });
        }
      }
    });
  }

  remove_relationship(worksheet_id, action, relationship_type, $el) {
    return this.$confirm({
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('pbx.worksheet.modal.remove_relationship.content'),
      loading: true,
      animate: from_element($el),
      okText: i18n.t('shared.component.button.yes'),
      cancelText: i18n.t('shared.component.button.no'),
      onOk: () => {
        const after_remove = action.removeOption(relationship_type);
        const item = after_remove.toBackend();

        WorksheetItemService.updateData(item.type, worksheet_id, item.id, item.getData())
          .then(response_item => this._default_success(response_item))
          .catch(e => this._default_error(e));
      }
    });
  }

  get_config_modal_by_type(type) {
    const components = {
      start: Entry,
      // call: Call,
      // queue: Queue,
      menu: Menu,
      media: Playback,
      postback: Postback
      // time: Time,
      // list: List
    };

    if (type in components) {
      return components[type];
    }
    return null;
  }

  config(worksheet_id, box, $el) {
    const { type } = box;

    return this.$open({
      render: h =>
        h(this.get_config_modal_by_type(type), {
          props: {
            box: box
          },
          on: {
            ['on-save']: item => {
              this.modal.setLoading(true);
              const backend = WorksheetActionModelSelector.getFrontendModel(item).toBackend();
              WorksheetItemService.createOrUpdateItem(
                backend.type,
                worksheet_id,
                backend.id,
                backend
              )
                .then(item => this._default_success(item))
                .catch(e => this._default_error(e))
                .finally(() => this.modal.setLoading(false));
            }
          }
        }),
      animate: from_element($el)
    });
  }

  create_connection(from, to, $el) {
    const components = {
      call: ConnectionWithTimeout,
      queue: ConnectionWithTimeout,
      menu: PhoneKeyboard,
      time: PositiveNegative,
      list: PositiveNegative
    };

    return this.$open({
      render: h =>
        h(components[from.type], {
          props: {
            box: from
          },
          on: {
            confirm: type => this.$emit('confirm', { from, to, type })
          }
        }),
      width: this.size.confirm,
      animate: from_element($el)
    });
  }
}

const instance = new WorksheetActionModalService();
export { instance as WorksheetActionModalService };
